<template>
  <AccessErrorBase>
    <template #title>
      New to Starfish?
    </template>
    <template #errorTitle>
      Request Access to a Starfish Site
    </template>
    <template #errorText>
      It looks like you don’t have access to any Starfish sites yet.
      To get started, please submit an access request using the button below.
      If you know the site name, include it in your request. If not, no problem —
      just submit the form and our team will reach out to assist you.
    </template>
    <template #actions>
      <v-btn color="#328FFF" block x-large @click="requestAccess">
        <span class="white--text">Request Access</span>
      </v-btn>
    </template>
  </AccessErrorBase>
</template>

<script>
import {
  mapActions,
  mapGetters,
} from 'vuex';

import AccessErrorBase from '@/components/common/siteCheck/AccessErrorBase.vue';
import StarfishRegistrationRequestForm
from '@/lib/requestAccess/models/StarfishRegistrationRequestForm';
import DiscoveryDialogOptions from '@/components/ui/dialogs/DiscoveryDialogOptions';
import { DiscoveryDialogTypes } from '@/lib/ui/dialogs/DiscoveryDialogsFactory';

export default {
  name: 'NoSitesAssignedError',
  components: {
    AccessErrorBase,
  },
  computed: {
    ...mapGetters('common', [
      'userEmail',
    ]),
  },
  methods: {
    ...mapActions('common', [
      'openDialog',
    ]),
    requestAccess() {
      const form = new StarfishRegistrationRequestForm();
      form.email = this.userEmail;

      const dialogOptions = new DiscoveryDialogOptions(DiscoveryDialogTypes.REQUEST_ACCESS, form,
        () => console.log('Closed'));
      this.openDialog(dialogOptions);
    },
  },
};
</script>

<style scoped>

</style>
